<template>
  <div class="admin-login">
    <!-- 左侧品牌区 -->
    <aside class="admin-login-brand">
      <div class="brand-bg" />
      <div class="brand-overlay" />
      <div class="brand-content">
        <div class="brand-logo-row">
          <img :src="logo" alt="安心陪护" class="brand-logo-img" />
          <div>
            <h1 class="brand-title">{{ projectName }}</h1>
            <p class="brand-subtitle">运营调度后台</p>
          </div>
        </div>
        <p class="brand-slogan">连接家属、护工与调度三端<br />让陪护服务全程可管可控</p>
        <ul class="brand-features">
          <li v-for="item in brandFeatures" :key="item">
            <span class="feature-dot" />
            {{ item }}
          </li>
        </ul>
        <p class="brand-footer">一期 · 调度 · 履约 · 结算</p>
      </div>
    </aside>

    <!-- 右侧登录区 -->
    <main class="admin-login-main">
      <div class="login-panel">
        <div class="login-panel-header">
          <div class="mobile-brand">
            <img :src="logo" alt="" class="mobile-logo" />
            <span>{{ projectName }}</span>
          </div>
          <h2 class="login-title">欢迎登录</h2>
          <p class="login-subtitle">使用调度员账号登录运营调度后台</p>
        </div>

        <a-form :form="form" @submit="handleSubmit" class="login-form">
          <div class="form-group">
            <label class="form-label">用户名</label>
            <a-form-item :validate-status="usernameError() ? 'error' : ''" :help="usernameError() || ''">
              <a-input
                class="form-input"
                type="text"
                size="large"
                v-decorator="['username', { rules: [{ required: true, message: '请输入用户名!' }] }]"
                placeholder="请输入用户名"
              />
            </a-form-item>
          </div>

          <div class="form-group">
            <label class="form-label">密码</label>
            <a-form-item :validate-status="passwordError() ? 'error' : ''" :help="passwordError() || ''">
              <a-input
                class="form-input"
                :type="type"
                size="large"
                v-decorator="['password', { rules: [{ required: true, message: '请输入密码!' }] }]"
                placeholder="请输入密码"
              >
                <a-icon
                  slot="suffix"
                  :type="type === 'password' ? 'eye' : 'eye-invisible'"
                  class="password-toggle"
                  @click="togglePassword"
                />
              </a-input>
            </a-form-item>
          </div>

          <div class="form-group">
            <label class="form-label">验证码</label>
            <a-form-item :validate-status="captchaError() ? 'error' : ''" :help="captchaError() || ''">
              <div class="captcha-row">
                <a-input
                  class="form-input captcha-text-input"
                  size="large"
                  v-decorator="[
                    'captcha',
                    {
                      rules: [
                        { required: true, message: '请输入验证码!' },
                        { validator: checkCode },
                      ],
                    },
                  ]"
                  placeholder="请输入验证码"
                />
                <button
                  type="button"
                  class="captcha-box"
                  title="点击更换验证码"
                  @click="onChangeCode"
                >
                  <img v-if="code" :src="code" alt="验证码" class="captcha-img" />
                  <a-icon v-else type="loading" class="captcha-loading" />
                </button>
              </div>
            </a-form-item>
          </div>

          <div class="form-options">
            <a-checkbox class="remember-checkbox">记住我</a-checkbox>
            <a class="forgot-link" @click="forgot">忘记密码?</a>
          </div>

          <a-button
            type="primary"
            html-type="submit"
            :disabled="hasErrors(form.getFieldsError())"
            :loading="loginLoading"
            class="login-button"
          >
            登录
          </a-button>
        </a-form>
      </div>

      <p class="login-copyright">© {{ year }} 安心陪护 · 运营调度后台</p>
    </main>

    <forgot :visible="forgotIsShow" @update="(val) => (forgotIsShow = false)" />
    <a-drawer
      :width="360"
      title="修改密码"
      placement="right"
      @close="closePassword"
      :visible="passwordVisible"
      :wrapStyle="{ overflow: 'auto', paddingBottom: '108px' }"
    >
      <password-login />
    </a-drawer>
  </div>
</template>

<script>
import forgot from "./forgot";
import brandLogo from "../../common/brandLogo";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
export default {
  name: "Login",
  components: {
    forgot,
  },
  data: function () {
    return {
      type: "password",
      code: "",
      uuid: "",
      hasErrors,
      form: this.$form.createForm(this),
      forgotIsShow: false,
      loginLoading: false,
      passwordVisible: false,
      year: new Date().getFullYear(),
      brandFeatures: ["订单调度与派单管理", "护工 KYC 与资质审核", "履约打卡与结算对账"],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    projectName() {
      return this.$store.state.projectName;
    },
    logo() {
      return brandLogo;
    },
  },
  mounted() {
    document.title = "运营调度后台 - 安心陪护";
    this.$nextTick(() => {
      this.form.validateFields();
    });
    this.onChangeCode();
  },
  methods: {
    closePassword() {
      this.passwordVisible = false;
    },
    openPassword() {
      this.passwordVisible = true;
    },
    checkCode(rule, value, callback) {
      value = value ? value.toLowerCase() : value;
      if (value === "") {
        return true;
      }
      return value.length < 4 ? callback("验证码错误") : true;
    },
    usernameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("username") && getFieldError("username");
    },
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("password") && getFieldError("password");
    },
    captchaError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("captcha") && getFieldError("captcha");
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loginLoading = true;
          values.uuid = this.uuid;
          this.axios({
            url: "web/auth/login",
            data: values,
            method: "post",
          })
            .then((response) => {
              if (response.data.success) {
                this.$setCookie("token", response.data.data.token, 7);
                this.$store.commit("setToken", response.data.data.token);
                this.$store.commit("updateUser", response.data.data.user);
                this.$store.commit("setLogin");
                this.$message.success("登录成功！");
                const redirect = this.$route.query.redirect || "/dispatch/orders";
                this.$router.push(redirect);
              } else {
                if (response.data.msg == "账号密码有效期已超时，请联系管理员续期！") {
                  this.$message.error("账号密码有效期已超时，请修改密码！");
                  this.openPassword();
                } else {
                  this.$message.error(response.data.msg);
                }
                this.onChangeCode();
              }
              this.loginLoading = false;
            })
            .catch(() => {
              this.$message.error("登录失败，请检查网络连接或联系管理员");
              this.loginLoading = false;
            });
        }
      });
    },
    togglePassword() {
      this.type = this.type === "password" ? "text" : "password";
    },
    onChangeCode() {
      this.code = null;
      this.axios({
        url: "web/auth/getCaptcha",
        method: "get",
      })
        .then((response) => {
          if (response.data.success) {
            this.code = response.data.data.img;
            this.uuid = response.data.data.uuid;
          } else {
            this.$message.error(response.data.msg);
          }
        })
        .catch(() => {
          this.$message.error("验证码加载失败，请检查网络或稍后重试");
        });
    },
    forgot() {
      this.forgotIsShow = true;
    },
  },
};
</script>

<style scoped>
.admin-login {
  min-height: 100vh;
  display: flex;
  background: #f0f7fc;
}

/* ========== 左侧品牌 ========== */
.admin-login-brand {
  display: none;
  position: relative;
  flex: 0 0 44%;
  max-width: 560px;
  overflow: hidden;
  color: #fff;
}

.brand-bg {
  position: absolute;
  inset: 0;
  background: url("/images/family-hero-banner.png") center right / cover no-repeat;
  background-color: #005fa3;
}

.brand-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(160deg, rgba(0, 72, 130, 0.92) 0%, rgba(0, 130, 212, 0.78) 55%, rgba(0, 166, 133, 0.35) 100%);
}

.brand-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3rem 3.5rem;
}

.brand-logo-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.brand-logo-img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  flex-shrink: 0;
}

.brand-title {
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0.02em;
}

.brand-subtitle {
  margin: 0.25rem 0 0;
  font-size: 0.875rem;
  opacity: 0.85;
}

.brand-slogan {
  font-size: 1.125rem;
  line-height: 1.7;
  font-weight: 500;
  margin: 0 0 2rem;
  opacity: 0.95;
}

.brand-features {
  list-style: none;
  padding: 0;
  margin: 0 0 2.5rem;
}

.brand-features li {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.9rem;
  margin-bottom: 0.875rem;
  opacity: 0.9;
}

.feature-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #7ee8c7;
  flex-shrink: 0;
}

.brand-footer {
  margin: 0;
  font-size: 0.75rem;
  opacity: 0.65;
  letter-spacing: 0.08em;
}

/* ========== 右侧登录 ========== */
.admin-login-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  min-height: 100vh;
}

.login-panel {
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 1.25rem;
  padding: 2.25rem 2rem 2rem;
  box-shadow: 0 8px 40px rgba(0, 80, 140, 0.08), 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 130, 212, 0.08);
}

.login-panel-header {
  margin-bottom: 1.75rem;
}

.mobile-brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  font-weight: 700;
  color: #0082d4;
  font-size: 1rem;
}

.mobile-logo {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.login-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.375rem;
}

.login-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

.login-form {
  margin: 0;
}

.form-group {
  margin-bottom: 0.25rem;
}

.form-label {
  display: block;
  color: #334155;
  font-size: 0.8125rem;
  font-weight: 500;
  margin-bottom: 0.375rem;
}

.form-input {
  height: 46px !important;
  border-radius: 0.75rem !important;
  border: 1px solid #e2e8f0 !important;
  font-size: 0.875rem !important;
  background: #f8fafc !important;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s !important;
}

.form-input:hover,
.form-input:focus {
  border-color: #0082d4 !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(0, 130, 212, 0.12) !important;
}

.login-panel >>> .ant-form-item {
  margin-bottom: 1rem !important;
}

.login-panel >>> .ant-input-affix-wrapper {
  border: 1px solid #e2e8f0 !important;
  border-radius: 0.75rem !important;
  background: #f8fafc !important;
  padding: 0 0.75rem !important;
  height: 46px !important;
}

.login-panel >>> .ant-input-affix-wrapper:hover,
.login-panel >>> .ant-input-affix-wrapper-focused {
  border-color: #0082d4 !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(0, 130, 212, 0.12) !important;
}

.login-panel >>> .ant-input-affix-wrapper .ant-input {
  background: transparent !important;
  border: none !important;
  height: 44px !important;
}

.login-panel >>> .ant-input-group {
  display: flex !important;
  border-radius: 0.75rem !important;
  overflow: hidden !important;
  border: 1px solid #e2e8f0 !important;
  background: #f8fafc !important;
  transition: border-color 0.2s, box-shadow 0.2s !important;
}

.login-panel >>> .ant-input-group:focus-within {
  border-color: #0082d4 !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(0, 130, 212, 0.12) !important;
}

.login-panel >>> .ant-input-group .ant-input {
  border: none !important;
  background: transparent !important;
  height: 44px !important;
  box-shadow: none !important;
}

.captcha-row {
  display: flex;
  align-items: stretch;
  gap: 0.625rem;
}

.captcha-text-input {
  flex: 1;
  min-width: 0;
}

.captcha-box {
  flex-shrink: 0;
  width: 108px;
  height: 46px;
  padding: 0;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  background: #fff;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.captcha-box:hover {
  border-color: #0082d4;
  box-shadow: 0 0 0 3px rgba(0, 130, 212, 0.12);
}

.captcha-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.captcha-loading {
  color: #94a3b8 !important;
  font-size: 1rem !important;
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.5rem 0 1.25rem;
}

.remember-checkbox {
  color: #64748b;
  font-size: 0.8125rem;
}

.forgot-link {
  color: #0082d4;
  font-size: 0.8125rem;
  cursor: pointer;
}

.forgot-link:hover {
  color: #006bb3;
}

.login-button {
  width: 100% !important;
  height: 48px !important;
  border-radius: 0.75rem !important;
  background: linear-gradient(135deg, #0082d4 0%, #006bb3 100%) !important;
  border: none !important;
  font-size: 0.9375rem !important;
  font-weight: 600 !important;
  box-shadow: 0 6px 20px rgba(0, 130, 212, 0.35) !important;
  margin-bottom: 1.25rem;
}

.login-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #0070b8 0%, #005a96 100%) !important;
  transform: translateY(-1px);
}

.login-button:disabled {
  background: #cbd5e1 !important;
  box-shadow: none !important;
}

.login-copyright {
  margin-top: 2rem;
  font-size: 0.75rem;
  color: #94a3b8;
}

.password-toggle {
  color: #94a3b8 !important;
  cursor: pointer;
}

.password-toggle:hover {
  color: #0082d4 !important;
}

.login-panel >>> .ant-form-explain {
  font-size: 0.75rem !important;
}

@media (min-width: 900px) {
  .admin-login-brand {
    display: block;
  }

  .mobile-brand {
    display: none;
  }

  .login-panel {
    padding: 2.5rem 2.25rem;
  }
}

@media (max-width: 480px) {
  .login-panel {
    padding: 1.75rem 1.25rem;
    border-radius: 1rem;
    box-shadow: none;
    border: none;
    background: transparent;
  }

  .admin-login-main {
    padding: 1rem;
  }
}
</style>
